let _isOffice = false;

/**
 * Call once during bootstrap with the `host` value from `Office.onReady()`.
 * When `host` is non-null the app is running inside an Office application.
 */
export function initOfficeEnvironment(host: unknown): void {
  _isOffice = host != null;
}

/**
 * Returns true if running inside an Office host (Word, Excel, etc.).
 */
export function isOfficeEnvironment(): boolean {
  return _isOffice;
}

/**
 * Returns true if the current window is an Office dialog callback
 * (i.e. the page loaded inside the dialog after auth completes).
 */
export function isOfficeDialog(): boolean {
  const params = new URLSearchParams(window.location.search);
  return params.has("officeAuthCallback");
}
